"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../common");
const constant_1 = require("./constant");
const Colors_1 = require("../../../../Colors");
const lodash_1 = __importDefault(require("lodash"));
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const Paging_1 = __importDefault(require("../../../../common/element/Paging"));
const BarGraph_1 = __importDefault(require("../../../../common/element/BarGraph"));
// SurveyResultItem 컴포넌트
const SurveyResultItem = react_1.default.memo(({ index, item, isRegist, frequencies }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [data, setData] = react_1.default.useState();
    const [statItem, setStatItem] = (0, react_1.useState)([]);
    const [tableList, setTableList] = (0, react_1.useState)([]);
    const titleRef = react_1.default.useRef(null);
    const [page, setPage] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(5);
    // 드롭다운 값 상태
    const [dropValue, setDropValue] = react_1.default.useState(constant_1.DEFAULT_SURVEY_DROP);
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEqual(data, item))
            return;
        const newDropValue = constant_1.SURVEY_DROP_LIST.find(drop => drop.id === item.type) || constant_1.DEFAULT_SURVEY_DROP;
        setDropValue(newDropValue);
        if (titleRef.current)
            titleRef.current.value = item.title || '';
        setData(item);
        setTableList(frequencies[item.id]?.slice(page * count, (page + 1) * count));
    }, [item]);
    (0, react_1.useEffect)(() => {
        if (!frequencies || !data)
            return;
        const raw = frequencies[data.id] || [];
        const replaced = raw.map(item => ({
            ...item,
            value: item.value === '' ? '무응답' : item.value,
        }));
        // const mockData = [
        // 	{ value: "11111", count: 32 },
        // 	{ value: "10000", count: 2 },
        // 	{ value: "55555", count: 2 },
        // 	{ value: "66666", count: 1 },
        // 	{ value: "88888", count: 1 },
        // 	{ value: "22222", count: 4 },
        // 	{ value: "33333", count: 2 },
        // 	{ value: "44444", count: 5 },
        // 	{ value: "77777", count: 1 },
        // 	{ value: "99999", count: 3 },
        // 	{ value: "111111", count: 32 },
        // 	{ value: "100001", count: 2 },
        // 	{ value: "555551", count: 2 },
        // 	{ value: "666661", count: 1 },
        // 	{ value: "888881", count: 1 },
        // 	{ value: "222221", count: 4 },
        // 	{ value: "333331", count: 2 },
        // 	{ value: "444441", count: 5 },
        // 	{ value: "777771", count: 1 },
        // 	{ value: "999991", count: 3 },
        // 	{ value: "111112", count: 32 },
        // 	{ value: "100002", count: 2 },
        // 	{ value: "555552", count: 2 },
        // 	{ value: "666662", count: 1 },
        // 	{ value: "888882", count: 1 },
        // 	{ value: "222222", count: 4 },
        // 	{ value: "333333", count: 2 },
        // 	{ value: "444444", count: 5 },
        // 	{ value: "777777", count: 1 },
        // 	{ value: "999999", count: 3 },
        // 	{ value: "1111112", count: 32 },
        // 	{ value: "1000012", count: 2 },
        // 	{ value: "5555512", count: 2 },
        // 	{ value: "6666612", count: 1 },
        // 	{ value: "8888812", count: 1 },
        // 	{ value: "2222212", count: 4 },
        // 	{ value: "3333312", count: 2 },
        // 	{ value: "4444412", count: 5 },
        // 	{ value: "7777712", count: 1 },
        // 	{ value: "9999912", count: 3 },
        // ];
        setStatItem(replaced);
    }, [frequencies, data]);
    // 드롭다운 변경 핸들러
    const handleDropChange = (dropItem) => {
        setDropValue(dropItem);
        APP.eventManager.publish('UPDATE_SURVEY_ITEM', {
            id: item.id,
            data: { type: dropItem.id },
        });
    };
    const renderQuestion = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "survey-title" },
        react_1.default.createElement("p", null,
            " Q",
            index + 1,
            ". "),
        isRegist ? (react_1.default.createElement(common_1.InputElement, { ref: titleRef, className: `survey-input ${isMobile ? '' : 'body4 '}`, type: "text", defaultValue: data?.title, placeholder: t('survey.inputQuestionPlaceholder'), onChange: value => {
                setData({ ...data, title: value });
                APP.eventManager.publish('UPDATE_SURVEY_ITEM', {
                    id: data.id,
                    data: { title: value },
                });
            } })) : (react_1.default.createElement("p", null, data?.title)))), [index, titleRef, data]);
    const renderType = (0, react_1.useMemo)(() => (
    /* 드롭다운 */
    react_1.default.createElement(common_1.DropDown, { className: "dropdown-mini", value: dropValue, list: constant_1.SURVEY_DROP_LIST, setDropValue: handleDropChange, option: {
            titleIcon: { show: false },
            itemIcon: { show: false },
        }, styles: {
            dropWrap: { width: isMobile ? '100%' : 85 },
            titleWrap: { backgroundColor: Colors_1.Colors.transparent, height: '100%' },
        }, isDisable: !isRegist })), [dropValue]);
    const pieData = DataValue => {
        const data = DataValue.map(item => ({
            id: item.value,
            value: item.count,
        }));
        return data;
    };
    // const pagingCount = 3;
    // const showCount = frequencies ? frequencies[item.id].length : 0;
    // const showCount = 5;
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } }, t(`assignment.noSubmit`))), []);
    if (!data)
        return null;
    return (react_1.default.createElement("div", { className: "survey body4", key: index },
        react_1.default.createElement("div", { className: "survey-header" },
            renderQuestion,
            renderType),
        react_1.default.createElement("div", { className: "survey-result" },
            react_1.default.createElement("div", { className: "survey-content" }, dropValue.id === constant_1.SURVEY_TYPE.CHECKBOX ||
                dropValue.id === constant_1.SURVEY_TYPE.OBJECTIVE ? (react_1.default.createElement(react_1.default.Fragment, null, statItem && statItem.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "survey_option_detail active" },
                    react_1.default.createElement(BarGraph_1.default, { data: statItem })),
                react_1.default.createElement("table", { className: "survey-table" },
                    react_1.default.createElement("thead", { className: "survey-data-header" },
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", null, "\uB2F5\uBCC0"),
                            react_1.default.createElement("th", { className: "count-column" }, "\uAC1C\uC218"))),
                    react_1.default.createElement("tbody", null, statItem.map((answer, index) => (react_1.default.createElement("tr", { key: index },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("p", { className: "overText" }, answer.value)),
                        react_1.default.createElement("td", { className: "count-column" }, answer.count)))))))) : (renderEmpty))) : statItem && statItem.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("table", { className: "survey-table" },
                    react_1.default.createElement("thead", { className: "survey-data-header" },
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", null, "\uB2F5\uBCC0"),
                            react_1.default.createElement("th", { className: "count-column" }, "\uAC1C\uC218"))),
                    react_1.default.createElement("tbody", null, statItem
                        .slice(page * count, (page + 1) * count)
                        .map((answer, index) => (react_1.default.createElement("tr", { key: index },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("p", { className: "overText" }, answer.value)),
                        react_1.default.createElement("td", { className: "count-column" }, answer.count)))))),
                statItem.length > 5 && (react_1.default.createElement(Paging_1.default
                // 페이지 버튼을 3개만 그리던 것을 다른 표와 같이 데스크톱 10개/모바일 5개로 —
                // 답변이 16건 이상일 때 4페이지 이후가 화살표로만 접근돼 "3페이지까지만" 보이던 문제
                , { 
                    // 페이지 버튼을 3개만 그리던 것을 다른 표와 같이 데스크톱 10개/모바일 5개로 —
                    // 답변이 16건 이상일 때 4페이지 이후가 화살표로만 접근돼 "3페이지까지만" 보이던 문제
                    defaultShowCount: isMobile ? 5 : 10, showCount: 5, page: page, pagingCount: isMobile ? 5 : 10, data: statItem, totalCount: statItem.length, handlerMoreData: handlerMoreData })))) : (renderEmpty)),
            isRegist && (react_1.default.createElement("div", { className: "survey-footer" },
                react_1.default.createElement(common_1.Button, { styles: {
                        buttonWrap: {
                            background: Colors_1.Colors.transparent,
                        },
                    }, onClick: () => APP.eventManager.publish('DELETE_SURVEY_ITEM', { id: item.id }), option: {
                        buttonBeforeIcon: {
                            show: true,
                            name: 'del-survey',
                            size: isMobile ? 14 : 20,
                            color: Colors_1.Colors.black,
                        },
                    } }),
                react_1.default.createElement(common_1.Button, { styles: {
                        buttonWrap: {
                            background: Colors_1.Colors.transparent,
                        },
                    }, onClick: () => APP.eventManager.publish('ADD_SURVEY_ITEM'), option: {
                        buttonBeforeIcon: {
                            show: true,
                            name: 'add-survey',
                            size: isMobile ? 14 : 20,
                            color: Colors_1.Colors.black,
                        },
                    } }))))));
});
exports.default = SurveyResultItem;
